import type {Pagination} from '../../../Data/types/BaseResponse';
import {MarketerTrackingAPIDataSource} from '../api/MarketerTrackingAPIDataSource';
import {mapSessionSummaryDTOToModel, mapSessionTrackDTOToModel} from '../mappers/session.mapper';
import type {SessionFilters, SessionTrack, WorkSession} from '../models/session.model';
import type {MarketerTrackingRepository} from './MarketerTrackingRepository';

export class MarketerTrackingRepositoryImpl implements MarketerTrackingRepository {
  async getSessions (filters: SessionFilters): Promise<{sessions: WorkSession[]; pagination: Pagination}> {
    const result = await MarketerTrackingAPIDataSource.getSessions(filters);
    return {
      sessions: result.data.map(mapSessionSummaryDTOToModel),
      pagination: result.pagination
    };
  }

  async getSessionDetails (sessionId: number | string): Promise<WorkSession> {
    const dto = await MarketerTrackingAPIDataSource.getSessionDetails(sessionId);
    return mapSessionSummaryDTOToModel(dto);
  }

  async getSessionTrack (sessionId: number | string): Promise<SessionTrack> {
    const dto = await MarketerTrackingAPIDataSource.getSessionTrack(sessionId);
    return mapSessionTrackDTOToModel(dto);
  }

  async getMarketerSessions (
    marketerId: number | string,
    filters: Omit<SessionFilters, 'marketerId'>
  ): Promise<{sessions: WorkSession[]; pagination: Pagination}> {
    const result = await MarketerTrackingAPIDataSource.getMarketerSessions(marketerId, filters);
    return {
      sessions: result.data.map(mapSessionSummaryDTOToModel),
      pagination: result.pagination
    };
  }
}
